import LoadingIndicator from "./indicator"

const staticIndicator = (
  <LoadingIndicator global={true}>Fetching Data...</LoadingIndicator>
)

export default staticIndicator
